import { useEffect, useState } from 'react';
import { Button } from '@/components/ui';

interface OverquotaScreenProps {
  title?: string;
  message?: string;
  returnUrl?: string;
  autoRedirect?: boolean;
  redirectDelay?: number;
}

export function OverquotaScreen({
  title = 'Survey is full',
  message = "We've received enough responses for your demographic group. Thank you for your interest.",
  returnUrl,
  autoRedirect = true,
  redirectDelay = 3,
}: OverquotaScreenProps) {
  const [countdown, setCountdown] = useState(redirectDelay);

  useEffect(() => {
    if (!returnUrl || !autoRedirect) return;

    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          window.location.href = returnUrl;
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [returnUrl, autoRedirect]);

  const handleContinue = () => {
    if (returnUrl) {
      window.location.href = returnUrl;
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 p-4">
      <div className="max-w-md text-center">
        {/* Full icon */}
        <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-amber-100">
          <svg
            className="h-8 w-8 text-amber-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>

        <h1 className="mb-2 text-2xl font-semibold text-gray-900">{title}</h1>
        <p className="mb-6 text-gray-600">{message}</p>

        {returnUrl && (
          <>
            {autoRedirect && countdown > 0 ? (
              <p className="text-sm text-gray-500">
                Redirecting in {countdown} seconds...
              </p>
            ) : (
              <Button onClick={handleContinue} variant="primary">
                Continue
              </Button>
            )}
          </>
        )}
      </div>
    </div>
  );
}
